export function formatDateFrench(dateString: string): string {
    const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return `${date.getDate()} ${monthsFr[date.getMonth()]} ${date.getFullYear()}`;
}

export function calculatePercentage(part: number, total: number, digits = 0): number {
    if (total === 0) return 0;
    return ((part / total) * 100).toFixed(digits) as unknown as number;
}

export function formatAmount(amount: number) {
    const intFormat = new Intl.NumberFormat('fr-FR');
    return intFormat.format(amount);
}

export function formatDate(dateString: string, format = 'DD/MM/YYYY HH:mm') {
    const date = new Date(dateString);

    const map = {
        DD: String(date.getDate()).padStart(2, '0'),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        YYYY: date.getFullYear(),
        HH: String(date.getHours()).padStart(2, '0'),
        mm: String(date.getMinutes()).padStart(2, '0'),
        ss: String(date.getSeconds()).padStart(2, '0'),
    };

    let formatted = format;
    for (const [key, value] of Object.entries(map)) {
        formatted = formatted.replace(key, value as any);
    }

    return formatted;
}

export function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export const INTEGER_FORMAT_CONFIG = {
    masked: false,
    prefix: '',
    suffix: '',
    thousands: ' ',
    decimal: ',',
    precision: 0,
    disableNegative: true,
    disabled: false,
    min: null,
    max: null,
    allowBlank: false,
    minimumNumberOfCharacters: 0,
    shouldRound: true,
    focusOnRight: false,
};

export const AMOUNT_FORMAT_CONFIG = {
    masked: false,
    prefix: '',
    suffix: '',
    thousands: ' ',
    decimal: ',',
    precision: 2,
    disableNegative: false,
    disabled: false,
    min: null,
    max: null,
    allowBlank: false,
    minimumNumberOfCharacters: 0,
    shouldRound: true,
    focusOnRight: false,
};

export const PERCENTAGE_FORMAT_CONFIG = {
    masked: false,
    prefix: '',
    suffix: '',
    thousands: ' ',
    decimal: ',',
    precision: 0,
    disableNegative: true,
    disabled: false,
    min: 0,
    max: 100,
    allowBlank: false,
    minimumNumberOfCharacters: 1,
    shouldRound: true,
    focusOnRight: false,
};